module.exports = __webpack_public_path__ + "static/JPEG image 142-d0e7521c3d96fef64f2ada6519cba202.jpeg";